const usernameMinLength = 1;
const usernameMaxLength = 25;
module.exports.usernameMinLength = usernameMinLength;
module.exports.usernameMaxLength = usernameMaxLength;
module.exports.usernameLengthRegex = new RegExp(`^.{${usernameMinLength},${usernameMaxLength}}$`);
module.exports.usernameContentRegex = new RegExp(`^[a-zA-Z0-9._-]{${usernameMinLength},${usernameMaxLength}}$`);
module.exports.emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
